import classNames from 'classnames';

import { Typography } from '../';

import './FormInput.scss';

export interface FormInputProps extends React.PropsWithChildren {
  label?: string;
  required?: boolean;
  errorMessage?: string;
  className?: string;
  htmlFor?: string;
}

export const FormInput: React.FC<FormInputProps> = ({
  label,
  errorMessage,
  required,
  className,
  htmlFor,
  children,
}) => {
  return (
    <div className={classNames('custom-form-input', className)}>
      {label ? (
        <Typography variant="TEXT16" className="custom-form-input__label" as="label" htmlFor={htmlFor}>
          {label}
          {required && (
            <Typography color="red" as="span" variant="TEXT16">
              *
            </Typography>
          )}
          <div className="custom-form-input__input">{children}</div>
        </Typography>
      ) : (
        <div className="custom-form-input__input">{children}</div>
      )}
      {errorMessage && (
        <Typography variant="TEXT14" color="red" semibold className="custom-form-input__error">
          {errorMessage}
        </Typography>
      )}
    </div>
  );
};
